import {ColleagueShort, User} from '../../../types/users';
import Temp from '../../../assets/profile.svg';
import React from 'react';

type Props = {
    users: Array<User>;
};

export const ColleagueInlineAvatarList = ({users}: Props) => {
    return (
        <div className='inline cursor-pointer'>
            {users.slice(0, 2).map((user: User) => {
                return (
                    <img
                        key={user.pk}
                        className='rounded-[50%] inline-block mx-auto h-[38px] w-[38px] object-cover object-center
                            ml-[-12px] border-4 border-white bg-melon-light-grey-darker'
                        src={user?.photo_img?.file ?? Temp}
                        alt='colleague'
                    />
                );
            })}
            {users.length > 2 ?
                <span
                    className='rounded-[50%] inline-block mx-auto h-[38px] w-[38px] ml-[-12px] border-4 border-white
                        bg-melon-light-grey-darker text-center leading-[28px]'
                >
                    +{users.length - 2}
                </span>
                :
                <></>
            }
            {/*<img*/}
            {/*    className='inline-block ml-3'*/}
            {/*    src={IS}*/}
            {/*    alt='is'*/}
            {/*/>*/}
        </div>
    )
};
